import type { AnimAction } from '../render/characters';
import type { PlayerMode } from './playerSystem';

/** Read-only snapshot of what the player view needs to pick an animation action. */
export interface PlayerAnimFacts {
  mode: PlayerMode;
  /** Police/economy outcome in progress. */
  outcome: 'none' | 'busted' | 'wasted';
  /** The car being entered still has a ped driver (carjack). */
  vehicleHasDriver: boolean;
  /** The car being entered is locked and not ours (break-in). */
  vehicleLocked: boolean;
}

/**
 * Map player state to an animator action. Outcomes win over everything (the police pull you out of
 * the car into a busted/wasted pose); carjacks and break-ins use the yank-the-door steal variant.
 */
export function playerAction(f: PlayerAnimFacts): AnimAction {
  if (f.outcome === 'wasted') return 'wasted';
  if (f.outcome === 'busted') return 'busted';
  switch (f.mode) {
    case 'knocked':
      return 'knockdown';
    case 'entering':
      return f.vehicleHasDriver || f.vehicleLocked ? 'stealVehicle' : 'enterVehicle';
    case 'exiting':
      return 'exitVehicle';
    default:
      return 'none';
  }
}
